// libs
import { memo } from "react";
import styled from "@emotion/styled";

const Title = styled.div`
    font-size: 1.71rem;
    font-weight: 600;
    color: #000;
    margin-bottom: 30px;
`;

export default memo(Title);
